let parameters = {
  /**  title: {
        label: 'Title',
        class: 'xs12 sm12 d-flex',
        type: 'input',
        wait: false
    },**/
    content: {
        label: 'Title',
        source: 'parameters.never',
        items: [],
        types: [],
        item: {data: [], headers: []},
        class: 'xs12 sm12 d-flex',
        type: 'hidden',
        value: '<h2>Insert Title</h2>',
        display: false,
        wait: false
    },
    chartDataSource: {
        label: 'Chart Data',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: false
    },
    groupData: {
        label: 'Group',
        class: 'xs12 sm12',
        type: 'select',
        source: 'parameters.chartDataSource.item.headers',
        itemText: 'text',
        itemValue: 'value',
        items: [],
        item: {},
        wait: false
    },
    itemData: {
        label: 'Item',
        class: 'xs12 sm6',
        type: 'select',
        source: 'parameters.chartDataSource.item.headers',
        itemText: 'text',
        itemValue: 'value',
        items: [],
        item: {},
        wait: false
    },
    transformItemData: null,
    valueData: {
        label: 'Value',
        class: 'xs12 sm6',
        type: 'select',
        source: 'parameters.chartDataSource.item.headers',
        itemText: 'text',
        itemValue: 'value',
        item: {},
        items: [],
        wait: false
    },
    transformValueData: null,
    selectedFields: {
        label: 'Selected Fields',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: '_hidden',
        value: [],
        display: false,
        wait: false
    },
    selectedColumns: {
        label: 'Selected Fields',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: '_hidden',
        value: [],
        display: false,
        wait: false
    },
    title: {
        label: 'Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: "",
        display: true,
        wait: false
    },
    subtitle: {
        label: 'Sub Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: "",
        display: true,
        wait: false
    },
    itemTitle: {
        label: 'Item Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: "",
        display: true,
        wait: false
    },
    valueTitle: {
        label: 'Value Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: undefined,
        display: true,
        wait: false
    },
    legendPositionData : null,
    showLegendSource: null,
    horizontalSource: {
        label: 'Horizontal',
        class: 'xs12 xs12',
        type: 'switch',
        source: 'parameters.formatSource.aggregates',
        itemValue: 'format',
        value: false,
        items: [],
        item: {data: [], headers: []}
    },
    stackedSource: {
        label: 'Stacked',
        class: 'xs12 xs12',
        type: 'switch',
        source: 'parameters.formatSource.aggregates',
        itemValue: 'format',
        value: false,
        items: [],
        item: {data: [], headers: []}
    },
    themeDataSource: {
        label: 'Theme',
        class: 'xs12 sm12 d-flex',
        type: '_hidden',
        source: 'dataSources',
        itemText: 'name',
        itemValue: 'id',
        items: [],
        wait: false
    },
    colorGradient: {
        label: 'ThemeColor',
        class: 'xs12 sm12 d-flex',
        type: 'theme-color',
        source: 'parameters.themeDataSource.item.data',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [],
        wait: false,
        value: null
    }
};

export default parameters;
